module.exports = __webpack_public_path__ + "img/e_scooter_disabled.51c216f3.svg";